import { render, staticRenderFns } from "./friendinfo.vue?vue&type=template&id=d8450862&scoped=true&"
import script from "./friendinfo.vue?vue&type=script&lang=js&"
export * from "./friendinfo.vue?vue&type=script&lang=js&"
import style0 from "./friendinfo.vue?vue&type=style&index=0&id=d8450862&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8450862",
  null
  
)

export default component.exports